export default __webpack_public_path__ + "static/media/menu_icon02.0980607e.png";